<app-header [forceLightBackground]="true"></app-header>
<div class="admin-existing-entities">
  <div class="admin-existing-entities--layout">
    <app-admin-sidebar class="admin-existing-entities--sidebar"></app-admin-sidebar>
    <div class="admin-existing-entities--content">
      <app-page-header></app-page-header>
      <div class="existing-entities-container">
        
        <!-- Filter Section -->
        <app-filter-panel
          [fields]="filterFields"
          [defaultExpanded]="false"
          (filterChange)="onFilterChange($event)"
          (clearFilters)="onClearFilters()"
        ></app-filter-panel>

        <!-- Table -->
        <app-table
          [columns]="columns"
          [data]="entitiesData"
          [dropdownOpenRowIndex]="openDropdownRowIndex"
          [scrollHeight]="'400px'"
          [loading]="loading"
          [pagination]="pagination"
          [emptyMessage]="emptyMessage"
          [striped]="true"
          [bordered]="true"
          [hoverable]="true"
          (pageChange)="onPageChange($event)"
          (pageSizeChange)="onPageSizeChange($event)"
          (sortChange)="onSortChange($event)"
        >
          <!-- Custom Status Column -->
          <ng-template #statusCell let-row>
            <div [ngClass]="getStatusChipClass(row.status)">
              {{ row.status }}
            </div>
          </ng-template>

          <!-- Custom Action Column (dropdown in fixed overlay below) -->
          <ng-template #actionCell let-row let-rowIndex="rowIndex">
            <div class="action-cell-wrapper">
              <button 
                class="action-btn" 
                (click)="toggleActionDropdown($event, row, rowIndex)"
                [class.active]="isDropdownOpen(rowIndex)"
              >
                <span>Action</span>
              </button>
            </div>
          </ng-template>
        </app-table>
        
      </div>
    </div>
  </div>
</div>

<!-- Fixed overlay: dropdown on top of table -->
<div
  *ngIf="dropdownPosition && openDropdownRow"
  class="action-dropdown-overlay"
  [style.top.px]="dropdownPosition.top"
  [style.left.px]="dropdownPosition.left"
  [style.min-width.px]="dropdownPosition.width"
  (click)="$event.stopPropagation()"
>
  <ul class="dropdown-list">
    <li class="dropdown-item">
      <button type="button" class="dropdown-link" (click)="handleAction('view', openDropdownRow)">
        View
      </button>
    </li>
  </ul>
</div>

<!-- View Entity Modal -->
<app-modal
  [(visible)]="isViewModalVisible"
  [headerTemplate]="viewModalHeaderTemplate"
  [width]="'90vw'"
  [modal]="true"
  [closable]="true"
  [showFooter]="false"
  (onClose)="closeViewModal()"
>
  <app-data-provider-entity-form
    [formData]="viewFormData"
  ></app-data-provider-entity-form>
</app-modal>

<!-- View Modal Header Template with Status Chip -->
<ng-template #viewModalHeaderTemplate>
  <div class="modal-header-with-status">
    <span class="modal-header-title">Organisation Details</span>
    <div *ngIf="selectedEntity?.status" [ngClass]="getStatusChipClass(selectedEntity?.status || '')" class="modal-header-status-chip">
      {{ selectedEntity?.status }}
    </div>
  </div>
</ng-template>